import { Box, Container, Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";
import { ReactComponent as FinancialSVG } from "../../assets/img/finanicalintropage.svg";
import ACRButton from "../../commanComponents/ACRButton";
import { getColor } from "../../style/color/color";
import { useNavigate } from "react-router-dom";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const Introduction = () => {
  const naviagation = useNavigate();
  const { verifyData } = useContext(OTPVerifyContext);

  return (
    <Container>
      <PageTitle PageTitle={String.Monthlyincome.introduction} />
      <LinearProgressBar stepNumber={2} progress={20} progressNumber={20} />

      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          mt: { xs: "10%", md: "30%" },
          mb: "80px",
        }}
      >
        <FinancialSVG
          style={{
            width: "100%",
            maxWidth: "240px",
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            color: getColor.NeutralDark600,
            fontSize: 18,
            p: 3,
            mt: "30px",
            fontFamily: fonts.manrope,
            fontWeight: "500",
            textAlign: "center",
            textWrap: "pretty",
          }}
        >
          {String.Monthlyincome.introductionSubTitle}
        </Typography>
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "center", mt: "40px" }}>
        <ACRButton
          label={String.Monthlyincome.introductionScreenButton}
          style={{
            width: "100%",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "20px",
            mt: "20px",
            mb: "10px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={() => {
            gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioLetsGetStarted, verifyData.customerId);
            naviagation(String.navigations.financialquestion);
          }}
        />
      </Box>
    </Container>
  );
};

export default Introduction;
